import { render, staticRenderFns } from "./ArtistsDashlet.vue?vue&type=template&id=03e3b7bf"
import script from "./ArtistsDashlet.vue?vue&type=script&lang=js"
export * from "./ArtistsDashlet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports